import React from 'react'

const EpisodePlayIcon = () => (
  <svg width="55" height="55" viewBox="0 0 55 55" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_dd_170_5415)">
      <path d="M49.914 26.457C49.914 38.8596 39.8597 48.914 27.457 48.914C15.0543 48.914 5 38.8596 5 26.457C5 14.0543 15.0543 4 27.457 4C39.8597 4 49.914 14.0543 49.914 26.457Z" fill="#515151" fillOpacity="0.4" stroke="#F6F6F6" strokeWidth="2" />
      <path d="M21.8565 35.5321C22.2702 35.5321 22.6218 35.3632 23.0355 35.1204L35.095 28.0054C35.9534 27.4882 36.2534 27.1504 36.2534 26.5909C36.2534 26.0314 35.9534 25.6936 35.095 25.1869L23.0355 18.0613C22.6218 17.8185 22.2702 17.6602 21.8565 17.6602C21.0911 17.6602 20.6154 18.2513 20.6154 19.1697V34.012C20.6154 34.9304 21.0911 35.5321 21.8565 35.5321Z" fill="#F6F6F6" />
    </g>
    <defs>
      <filter id="filter0_dd_170_5415" x="0" y="0" width="54.914" height="54.9141" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_170_5415" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feMorphology radius="1" operator="dilate" in="SourceAlpha" result="effect2_dropShadow_170_5415" />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend mode="normal" in2="effect1_dropShadow_170_5415" result="effect2_dropShadow_170_5415" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_170_5415" result="shape" />
      </filter>
    </defs>
  </svg>
)

export default EpisodePlayIcon
